
<style scoped>

</style>


<template>
<div class="factitem">
    fact item
</div>
</template>

<script>

export default{
    data:function(){
        return {

        }
    }
}

</script>


// WEBPACK FOOTER //
// src/assets/Dynamic/app/neverendingfacts/neverendingfactscomponents/factscomponentitem.vue